const PREFIX = 'direct-message-draft:';
const MAX_AGE = 24 * 60 * 60 * 1000;
export const MAX_MESSAGE_LENGTH = 5000;

export interface DirectMessageDraft {
  expert: string;
  email: string;
  html: string;
  createdAt: number;
  threadId?: string;
  userId?: number;
}

export function messageTextToHtml(text: string): string {
  return `<p>${text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/\r?\n/g, '<br>')}</p>`;
}

export function saveMessageDraft(id: string, draft: DirectMessageDraft): void {
  sessionStorage.setItem(PREFIX + id, JSON.stringify(draft));
}

export function readMessageDraft(id: unknown): DirectMessageDraft | null {
  if (typeof id !== 'string' || !id) return null;
  try {
    const value = JSON.parse(sessionStorage.getItem(PREFIX + id) || 'null');
    if (!value || typeof value.expert !== 'string' || typeof value.email !== 'string'
      || typeof value.html !== 'string' || typeof value.createdAt !== 'number'
      || Date.now() - value.createdAt > MAX_AGE) return null;
    return value;
  } catch {
    return null;
  }
}

export function removeMessageDraft(id: string): void {
  sessionStorage.removeItem(PREFIX + id);
}

export function messageStartPath(expert: string, draft: string, source?: string): string {
  const params = new URLSearchParams({ expert, draft });
  if (source) params.set('cta_source', source);
  return `/client/messages/new?${params}`;
}

export function isMessageRedirect(value: unknown): value is string {
  return typeof value === 'string' && /^\/client\/messages(?:\/|\?|$)/.test(value)
    && !value.includes('\\');
}

export function authHandoffQuery(email: unknown, redirect: unknown): Record<string, string> {
  const query: Record<string, string> = {};
  if (typeof email === 'string') query.email = email.trim();
  if (typeof redirect === 'string' && redirect.startsWith('/client/') && !redirect.includes('\\')) {
    query.redirect = redirect;
  }
  return query;
}
